import { render, staticRenderFns } from "./SingleVehicleMsg.vue?vue&type=template&id=55767a8c&scoped=true"
import script from "./SingleVehicleMsg.vue?vue&type=script&lang=js"
export * from "./SingleVehicleMsg.vue?vue&type=script&lang=js"
import style0 from "./SingleVehicleMsg.vue?vue&type=style&index=0&id=55767a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55767a8c",
  null
  
)

export default component.exports